import React, { useState, useEffect, useRef } from "react";
import { UserIcon } from "./Icons/UserIcon";
import { LogoutIcon } from "./Icons/LogoutIcon";
import { LogoutConfirmationIcon } from "./Icons/LogoutConfirmationIcon";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Colors } from "../constants/Colors";

const DropdownItem = styled.button`
  color: rgb(83, 83, 83);

  &:hover {
    background-color: #d7d7d7;
  }
`;

export const HeaderProfile = ({ username, isUsernameVisible }) => {
  const ref = useRef();

  const [isProfileDropdownOpen, setIsProfileDropdown] = useState(false);
  const [isLogoutConfirmationModalOpen, setIsLogoutConfirmationModalOpen] =
    useState(false);

  const closeProfileDropdown = () => {
    setIsProfileDropdown(false);
  };

  const toggleProfileDropdown = () => {
    setIsProfileDropdown(!isProfileDropdownOpen);
  };

  const openLogoutConfirmationModal = () => {
    setIsLogoutConfirmationModalOpen(true);
  };

  const closeLogoutConfirmationModal = () => {
    setIsLogoutConfirmationModalOpen(false);
  };

  const handleScreenClick = (e) => {
    if (ref.current && !ref.current.contains(e.target)) closeProfileDropdown();
  };

  useEffect(() => {
    document.addEventListener("click", handleScreenClick);
    return () => {
      document.removeEventListener("click", handleScreenClick);
    };
  }, []);

  return (
    <div className="relative" ref={ref}>
      {!isUsernameVisible && (
        // only show the user icon if the username is not visible
        <div className="cursor-pointer py-2" onClick={toggleProfileDropdown}>
          <div
            style={{
              padding: "2px 0px",
              borderRadius: "10px",
              justifyContent: "flex-end",
              marginLeft: "10px",
            }}
          >
            <div
              className="ml-10 inline-flex h-10 items-center"
              style={{
                justifyContent: "flex-end",
              }}
            >
              <UserIcon />
            </div>
          </div>
        </div>
      )}
      {isUsernameVisible && (
        <div
          className="flex cursor-pointer items-center px-4 py-2"
          onClick={toggleProfileDropdown}
        >
          <div
            className="flex items-center"
            style={{
              border: "1px solid rgba(42, 52, 57, 0.5)",
              padding: "2px 5px",
              borderRadius: "10px",
            }}
          >
            <div className="mr-2 inline-flex h-10 w-10 items-center justify-center rounded-full text-center">
              <UserIcon />
            </div>
            <span className="inline-flex pr-3" style={{ color: "#535353" }}>
              {username}
            </span>
          </div>
        </div>
      )}
      <div
        className={`${
          !isProfileDropdownOpen ? "hidden" : ""
        } absolute right-4 top-auto mt-2 overflow-hidden rounded-md border text-right text-base font-medium shadow-md`}
        style={{
          minWidth: "160px",
          backgroundColor: "#FFFFFF",
        }}
      >
        {!isUsernameVisible && (
          <DropdownItem className="flex w-full items-center px-4 py-3">
            {username}
          </DropdownItem>
        )}
        <DropdownItem
          type="button"
          className="flex w-full items-center px-4 py-3"
          data-testid="logout-link"
          onClick={() => {
            openLogoutConfirmationModal();
            closeProfileDropdown();
          }}
        >
          <LogoutIcon style={{ width: "20px", marginRight: "15px" }} />
          Logout
        </DropdownItem>
      </div>

      <LogoutConfirmationModal
        isModalOpen={isLogoutConfirmationModalOpen}
        toggleModal={closeLogoutConfirmationModal}
      />
    </div>
  );
};

const LogoutConfirmationModal = ({ isModalOpen, toggleModal }) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    console.log("User logged out");
    localStorage.removeItem("access_token");
    localStorage.removeItem("token_type");
    localStorage.removeItem("login_type");
    navigate("/login");
  };

  const { t } = useTranslation();

  return (
    isModalOpen && (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
        <div
          className="w-full max-w-md transform rounded-xl bg-white p-6 text-left align-middle shadow-xl transition-all"
          style={{
            maxWidth: "22rem",
          }}
        >
          <div className="border-gunmetal-10 rounded-xl border p-5">
            <div className="modal-confirmation-body text-center">
              <div className="mb-4 flex justify-center">
                <LogoutConfirmationIcon />
              </div>
              <div className="title text-gunmetal-90 text-heading_4 mb-4 font-bold">
                Logout
              </div>
              <p className="description text-gunmetal-90 mb-4">
                {t("general.logout")}
              </p>
            </div>
            <div className="grid grid-cols-2 gap-3">
              <button
                type="button"
                onClick={toggleModal}
                style={{
                  color: "rgb(84, 93, 101)",
                  fontWeight: "bold",
                  padding: "8px",
                  borderRadius: "10px",
                  border: "1px solid rgb(84, 93, 101)",
                }}
              >
                {t("general.cancel")}
              </button>
              <button
                type="submit"
                onClick={handleLogout}
                style={{
                  backgroundColor: "rgb(19, 71, 128)",
                  color: Colors.white,
                  fontWeight: "bold",
                  padding: "8px",
                  borderRadius: "10px",
                }}
              >
                Logout
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  );
};
